import { ArchiveIcon } from '@src/components/icons/ArchiveIcon';
import { TrashIcon } from '@src/components/icons/TrashIcon';
import { useTranslation } from 'react-i18next';
import { Button, showDialog } from '@src/components';

export function HelpDeskArchiveBox({
  id,
  name,
  onArchived,
  onDenied,
  action = 'archive',
}: {
  action?: 'archive' | 'delete' | 'permanent';
  id: number;
  name: string;
  onArchived: () => void;
  onDenied: () => void;
}) {
  const { i18n } = useTranslation();
  const ru = i18n.language.startsWith('ru');
  const label =
    action === 'permanent'
      ? ru
        ? 'Удалить навсегда'
        : 'Delete permanently'
      : action === 'delete'
      ? ru
        ? 'Удалить игру'
        : 'Delete game'
      : ru
      ? 'Архивировать игру'
      : 'Archive game';
  function confirm(error = false) {
    showDialog({
      title: `${label} · #${id}`,
      children: (
        <>
          <p>
            {action === 'permanent'
              ? ru
                ? `Навсегда удалить игру «${name}» (#${id}) и все её данные: участников, ответы, события, подарки, сообщения и премиум-функции? Это действие нельзя отменить.`
                : `Permanently delete “${name}” (#${id}) and all its game data: participants, answers, events, gifts, messages and Premium features? This cannot be undone.`
              : action === 'delete'
              ? ru
                ? `Удалить архивную игру «${name}»? Данные останутся до окончательного удаления.`
                : `Delete archived game “${name}”? Data remains until permanent deletion.`
              : ru
              ? `Архивировать игру «${name}» для всех участников? Данные и результаты жеребьёвки сохранятся.`
              : `Archive “${name}” for all participants? Game data and draw results will be preserved.`}
          </p>
          {error && (
            <p role="alert">
              {ru
                ? 'Не удалось изменить игру. Обновите страницу и попробуйте ещё раз.'
                : 'Could not update game. Reload and retry.'}
            </p>
          )}
        </>
      ),
      cancel: ru ? 'Отмена' : 'Cancel',
      closeLabel: ru ? 'Закрыть' : 'Close',
      submit: label,
      testId: `help-desk-${action}-box-confirm`,
      onSubmit: async () => {
        try {
          const response = await fetch(
            `/api/admin/help-desk/boxes/${id}${
              action === 'archive' ? '/archive' : action === 'permanent' ? '/permanent' : ''
            }`,
            {
              method: action === 'archive' ? 'POST' : 'DELETE',
              credentials: 'same-origin',
            },
          );
          if ([401, 403].includes(response.status)) {
            onDenied();
            return;
          }
          if (!response.ok) throw new Error('Game action failed');
          onArchived();
        } catch (error) {
          confirm(true);
          throw error;
        }
      },
    });
  }
  return (
    <Button variant="ghost"
      className={`help-desk__action-button help-desk__action-button--${action === 'archive' ? 'archive' : 'delete'}`}
      icon={action === 'archive' ? <ArchiveIcon /> : <TrashIcon />}
      aria-label={label} title={label} onClick={() => confirm()} />
  );
}
